export { scrambledCardStyles } from '@utils/component-framework';

const contentWrapper = "_xkbc17pavms";
const textBox = "_xkbts8wfqh";
const line = "_xkbl105os58";

export { contentWrapper, line, textBox };
import "./comp.scrambled.style.linaria.module.css";
//# sourceMappingURL=comp.scrambled.style.js.map
